var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfosBulle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57,
    height: 59,
    viewBox: "0 0 57 59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#0082de;}.b{fill:#fff;font-size:25px;font-family:Roboto-Regular, Roboto;letter-spacing:0.01em;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.272)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 28.5,
    cy: 29.5,
    rx: 28.5,
    ry: 29.5,
    transform: "translate(0.272 0)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "b",
    transform: "translate(12.272 15)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 13.967,
    y: 23
  }, "i"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfosBulle);
export default __webpack_public_path__ + "static/media/infos-bulle.8d0baffc1f0157a3d2b1aecc0b4288f4.svg";
export { ForwardRef as ReactComponent };